import { Checkbox, InputAdornment } from "@mui/material";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import TableCell from "@mui/material/TableCell";
import TextField from "@mui/material/TextField";
import React from "react";

function getInputProps(type, endAdorn) {
  if (type === "rate") {
    return {
      InputProps: {
        endAdornment: (
          <InputAdornment position="end">%{endAdorn}</InputAdornment>
        ),
        type: "number",
      },
    };
  }
  if (type === "amount") {
    return {
      InputProps: {
        startAdornment: <InputAdornment position="start">£</InputAdornment>,
        endAdornment: endAdorn ? (
          <InputAdornment position="end">{endAdorn}</InputAdornment>
        ) : undefined,
        type: "number",
      },
    };
  }
  if (type === "term") {
    return {
      InputProps: {
        endAdornment: (
          <InputAdornment position="end">months{endAdorn}</InputAdornment>
        ),
        type: "number",
      },
    };
  }
}

export const InputCell = ({
  field,
  row,
  onChange,
  onBlur,
  type,
  disabled,
  min,
  max,
  allowInfinity,
  error,
}) => {
  const value = row[field];
  const valueNum = value !== "" ? parseFloat(value) : undefined;
  const isInfinity = valueNum === 999999999;
  const endAdorn = !!allowInfinity && (
    <Checkbox
      checked={isInfinity}
      onChange={(event) => {
        onChange({ [field]: event.target.checked ? "999999999" : "" });
      }}
      icon={<AllInclusiveIcon />}
      checkedIcon={<AllInclusiveIcon />}
    />
  );
  const inputProps = getInputProps(type, endAdorn);
  return (
    <TableCell>
      <TextField
        margin="none"
        sx={{
          width: 1,
          ...(disabled
            ? {
                ".MuiOutlinedInput-root": {
                  backgroundColor: "neutral.100",
                },
                ".MuiOutlinedInput-notchedOutline": { borderStyle: "dashed" },
              }
            : {}),
        }}
        disabled={!!disabled || isInfinity}
        {...inputProps}
        inputProps={{ min: min ?? 0, max }}
        value={value}
        error={!!error}
        helperText={error}
        onChange={(event) => onChange({ [field]: event.target.value })}
        onBlur={() => onBlur && onBlur()}
      />
    </TableCell>
  );
};
